export default __webpack_public_path__ + "static/curriculum_icon-097fbdf7a9d3df6a860746e922a4c417.svg";